import Phaser from 'phaser'
import { PIXEL_TO_TILEMAP_POSITION, PIXEL_NAME, SCALE, CLASS_NAMES, TICK_TIME } from '../../utils/constants'
import UI from '../UI'
import Destroyable from './Destroyable'
import Player from './Player'

export default class Ground extends Destroyable {
  constructor(id, level) {
    super({
      id,
      isRigid: true,
      isBreakable: true,
      isFlat: true,
      isPickable: false,
      isCrushable: false,
      level
    })
    this.strength = 1
  }

  overrunBy(el) {
    // assume is player who overruns ground
    const layer = this.level.scene.children.getByName('layer_1')
    // when player dies and level is restarting but explosions still occuring, layer is null
    if(!layer) return false
    const { tilemap: map } = layer
    
    map.putTileAt(-1, this.position.x, this.position.y, false, 'layer_1')

    this.level.scene.events.emit('sounds:clear_hit')
    
    if(!el) {
      // destroyed by explosion or earthquake
      this.break_effect = this.level.scene.add.sprite(48, 16).setOrigin(0, 0.25);
      this.break_effect.setScale(SCALE);
      this.break_effect.depth = 4;
      this.break_effect.x = UI.tileToScreen(this.position.x)
      this.break_effect.y = UI.tileToScreen(this.position.y)
      this.break_effect.play('ground_disolves')
      this.break_effect.setFlipY(true)
      this.break_effect.on(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
        this.break_effect.destroy()
      })
      // this.level.scene.plugins.get('rexFade').fadeOutDestroy(this.alien, 2000);
    }

    // we need to run this after level.objects updates from level.moveObject.
      // so we queue it for the next tick
      // this.level.onNextTick(level => {
      setTimeout(() => {
        const level = this.level
        // ** calcultate tile shape for each neighbour of removed tile **
    
        // cross neighbours coords offset (up, right, down, left)
        const neighboursCoords = [[0, -1], [1, 0], [0, 1], [-1, 0]]
        neighboursCoords.forEach(coords => {
          // create a 3x3 matrix to pass to calculateGroundTileWithNeighbours
          const data = Array(3).fill(0).map(() => Array(3).fill(0))
    
          // gets object from neighbour coordinate
          const x = this.position.x + coords[0]
          const y = this.position.y + coords[1]
          const neighbour = level.getObjectAt(x, y)
          
          // check if neighbour and it is a ground
          if (neighbour && neighbour.constructor.className === this.constructor.className) {
            // build data based on current neighbour, setting ground pixel or 0 accordingly.
            data[0][1] = level.getObjectAt(x, y-1)?.constructor.className === this.constructor.className ? PIXEL_NAME.GROUND : 0
            data[1][0] = level.getObjectAt(x-1, y)?.constructor.className === this.constructor.className ? PIXEL_NAME.GROUND : 0
            data[2][1] = level.getObjectAt(x, y+1)?.constructor.className === this.constructor.className ? PIXEL_NAME.GROUND : 0
            data[1][2] = level.getObjectAt(x+1, y)?.constructor.className === this.constructor.className ? PIXEL_NAME.GROUND : 0
    
            // gets and updates tile
            const tile = PIXEL_TO_TILEMAP_POSITION.calculateGroundTileWithNeighbours(1, 1, data)
            map.putTileAt(tile, x, y, false, 'layer_1')
          }
        })
      }, TICK_TIME / 8)
  }
}

Ground.className = CLASS_NAMES.GROUND
